import { useTu } from "@src/appV2/i18n/useTu";
import { isDefined } from "@clipboard-health/util-ts";
import { Box } from "@mui/material";
import { Text } from "@src/appV2/redesign/components/Text";
import { useAgentProfilePicture } from "@src/appV2/ShiftBlock/hooks/useGetAgentProfilePicture";
import { UserChip } from "../../../components/Chip/UserChip";
import { type Professional } from "./types";

interface InviteSelectedProfessionalProps {
  professional: Professional;
  onRemove?: () => void;
}

export function InviteSelectedProfessional(props: InviteSelectedProfessionalProps) {
  const { tu } = useTu("schedule");

  const { professional, onRemove } = props;

  const { data: profileImageData } = useAgentProfilePicture(
    { agentId: professional.id, size: "small" },
    { enabled: !isDefined(professional.avatarUrl) }
  );

  const initials = professional.name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);

  const avatarSource = professional.avatarUrl ?? profileImageData?.distribution_url;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: 2,
        paddingX: 3,
        paddingY: 3,
      }}
    >
      <Text
        sx={(theme) => ({
          color: theme.palette.text.secondary,
        })}
        variant="body2"
      >
        {tu("Invited:")}
      </Text>
      <UserChip
        avatar={{
          src: avatarSource,
          fallback: initials,
        }}
        label={professional.name}
        onRemove={onRemove}
      />
    </Box>
  );
}
